/** @jsxImportSource @emotion/react */
import ToolBar from "components/MainComponents/ToolBar/ToolBar";
import { css, useTheme } from "@emotion/react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import NavigationBar from "components/MainComponents/NavigationBar/NavigationBar";
import Feedback from "components/MainComponents/Feedback/Feedback";
import VideoPopUp from "components/CommonUi/VideoPopUp/VideoPopUp";
import { useEffect, useState } from "react";
import { useNavBarLabelsService } from "services/useNavBarLabelsService";
import { UserActivityCreate } from "services/userActivityService";
import { useAuthPageCheck } from "hooks/useAuthPageCheck";
import { useUserDataService } from "services/useUserDataService";
import Loader from "components/MainComponents/Loader/Loader";

const RootLayout = () => {
  const theme = useTheme();
  const [showVideoPopUp, setShowVideoPopUp] = useState(false);
  const { navbarLabels } = useNavBarLabelsService();
  const { isAuthPage } = useAuthPageCheck();
  const { userData } = useUserDataService();
  const location = useLocation();
  
  const isAuthenticated = !!userData?.token;
  
  const closeVideoPopUp = () => {
    setShowVideoPopUp(false);
  };
  useEffect(()=>{
      UserActivityCreate(
         location.pathname,
      )

  },[location])
  
  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has("loginsuccess")) {
      setShowVideoPopUp(true);
      url.searchParams.delete("loginsuccess");        
      window.history.replaceState({}, document.title, url.toString());
    }
  }, []);

  const containerStyles = css`
  display: flex;
    flex-direction: column;
    flex-basis: 100%;
    margin: 90px ${theme.spacing["8xl"]} 80px 180px;

    @media (max-width: 768px) {
      margin: 72px 40px 80px 40px;
    }
  `;

  const centerContainerStyles = css`
    margin: 0;
    margin-top: 40px;
    `;

  if (!isAuthenticated && !isAuthPage) {
    return <Loader />;
  }

  return (
    <div className="root-layout">
      {/* NavigationBar only for logged-in users and not on auth pages */}
      {isAuthenticated && !isAuthPage && <NavigationBar />}

      {/* ToolBar only for logged-in users and not on auth pages */}
      {isAuthenticated && !isAuthPage && <ToolBar />}

      <div className="pageContainer" css={[containerStyles, isAuthPage && centerContainerStyles]}>
        <Outlet />
      </div>

      {/* Feedback and Video popup only for logged-in users */}
      {isAuthenticated && !isAuthPage && <Feedback />}
      {isAuthenticated &&
        showVideoPopUp &&
        navbarLabels?.video_url?.trim() && (
          <VideoPopUp closeVideoPopUp={closeVideoPopUp} />
        )}
    </div>
  );
};
export default RootLayout;
